/* Native disclosures: click/touch, keyboard, and theme-editor support. */
if (!customElements.get('doogee-image-menu')) {
  customElements.define('doogee-image-menu', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const details = this.querySelector('details');
      const summary = this.querySelector('summary');
      if (!details || !summary) return;
      const close = () => { details.open = false; };
      details.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(details.open));
      }, options);
      summary.addEventListener('click', () => {
        if (!details.open) {
          this.closest('.shopify-section')?.querySelectorAll('doogee-image-menu details[open]').forEach(other => {
            if (other !== details) other.open = false;
          });
        }
      }, options);
      this.querySelectorAll('.doogee-menu-card').forEach(card => {
        card.addEventListener('click', close, options);
      });
      summary.setAttribute('aria-expanded', String(details.open));
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) close();
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && details.open) {
          event.preventDefault();
          close();
          summary.focus();
        }
      }, options);
      window.addEventListener('resize', close, options);
      document.addEventListener('shopify:block:select', event => {
        if (event.detail?.blockId === this.dataset.blockId && summary.getClientRects().length) {
          this.closest('.shopify-section')?.querySelectorAll('doogee-image-menu details[open]').forEach(other => { other.open = false; });
          details.open = true;
        }
      }, options);
      document.addEventListener('shopify:block:deselect', event => {
        if (event.detail?.blockId === this.dataset.blockId) close();
      }, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
